import { render, staticRenderFns } from "./TextlFieldLoader.vue?vue&type=template&id=523a1ff1&scoped=true"
import script from "./TextlFieldLoader.vue?vue&type=script&lang=js"
export * from "./TextlFieldLoader.vue?vue&type=script&lang=js"
import style0 from "./TextlFieldLoader.vue?vue&type=style&index=0&id=523a1ff1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523a1ff1",
  null
  
)

export default component.exports